import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CardTypeComponent } from './card-type.component';
import {
  DepartmentService
} from '../../shared';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [CardTypeComponent],
  exports: [
    CardTypeComponent
  ],
  providers: [
    DepartmentService
  ]
})
export class CardTypeModule { }
